import { useAssistantStore } from '../store/assistant-store';
import { suggestionChips } from '../helpers/suggestion-chips';

export interface SuggestionChipsProps {
  /** The thread's message count — chips render only on an empty thread. */
  messageCount: number;
  /** A run is active — chips hide. */
  busy: boolean;
  /** Send the chip's full message through the thread's existing send path. */
  onSelect: (message: string) => void;
}

/**
 * FR-12 starter chips on the empty chat state. Record-aware via the store's
 * record context (a dismissed context falls back to the generic starters,
 * matching what the chat hook would actually attach to the send).
 */
export function SuggestionChips({
  messageCount,
  busy,
  onSelect,
}: SuggestionChipsProps) {
  const { recordContext, contextDismissed } = useAssistantStore();
  if (messageCount > 0 || busy) return null;
  const chips = suggestionChips(contextDismissed ? null : recordContext);
  return (
    <div
      data-slot='suggestion-chips'
      className='mt-8 flex flex-wrap items-center justify-center gap-2 px-4'
    >
      {chips.map((chip) => (
        <button
          key={chip.id}
          type='button'
          onClick={() => onSelect(chip.message)}
        className='rounded-full border border-primary-200 bg-white px-3 py-1
                     h-10 text-base font-normal text-gray-800 transition-colors hover:bg-primary-50'
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
}
